import BigNumber from 'bignumber.js'
import { useCallback } from 'react'
import { buyXP } from 'utils/calls'
import { useXpMerchantContract } from 'hooks/useContract'
import { TransactionResponse } from '@ethersproject/providers'
import { TransactionReceipt } from '@ethersproject/abstract-provider/src.ts/index'

const useBuyXP = (
  price: string,
  amount: string,
  walletAddress: string
) => {
  const xpMerchantContract = useXpMerchantContract()

  const handleBuyXP = useCallback(
    async (
      onTransactionSubmitted: (tx: TransactionResponse) => void,
      onSuccess: (receipt: TransactionReceipt) => void,
      onError: (receipt: TransactionReceipt) => void,
    ) => {
      const tx = await buyXP(
        xpMerchantContract,
        walletAddress,
        price,
        amount
      )
      onTransactionSubmitted(tx)
      const receipt = await tx.wait()
      if (receipt.status) {
        onSuccess(receipt)
      } else {
        onError(receipt)
      }
    },
    [amount, price, xpMerchantContract],
  )

  return { onBuyXP: handleBuyXP }
}

export default useBuyXP
